import { XMarkIcon } from '@heroicons/react/24/outline';
import ClipboardCopy from '../../../../components/form-control/CopyToClipboard';

const AgetLinkModal = ({
  onProceed,
  onClose,
  link
}: {
  onProceed: () => void;
  onClose: () => void;
  link: string;
}) => {
  return (
    <div className="">

      <div className="p-5 ">
        <ClipboardCopy copyText={link} />
      </div>
    </div>
  );
};

export default AgetLinkModal;
